import React, {Component} from 'react';
import './Header.css'
import {Link, withRouter} from 'react-router-dom'
const url = "https://user-loginapp.onrender.com/api/auth/userinfo";
class Header extends Component {

    constructor(){
        super();

        this.state={
            userData:'',
            userImg:'',
            userName:''
        }
    }

    handleLogout = () => {
        sessionStorage.removeItem('userinfo');
        sessionStorage.setItem('loginStatus',false);
        sessionStorage.removeItem('ltk');
        sessionStorage.removeItem('uName');
        sessionStorage.removeItem('uImg');
        this.setState({userData:''})
        this.props.history.push('/')
    }

    conditionalHeader = () => {
        if(this.state.userData.name ||  sessionStorage.getItem('uName') !== null){
            if(sessionStorage.getItem('uName') !== null){
                let name =  sessionStorage.getItem('uName');
                let image = sessionStorage.getItem('uImg');
                return(
                    <> <nav style={{backgroundColor:'#dedcd3'}}className="navbar navbar-inverse">
                    <div>
                    <span  className="nav navbar-nav navbar-left">
                            <li style={{ fontFamily: 'Raleway', color:'Highlight'}}><Link to="/" id="nav_a">FoodieBay</Link></li>
                        </span>
                      <ul className="nav navbar-nav navbar-right">  <div className="btnlogin">
                            <Link to="/" style={{color:'darkblue'}}>
                                <span className=""></span>
                                 Hi <img src={image} style={{height:25,width:25}}/> {name}
                            </Link> &nbsp;
                            <button style={{marginRight:'0%'}} onClick={this.handleLogout} className="btn btn-outline-secondary">Logout</button>
                        </div>
                        </ul></div>
            </nav>
                        
                    </>
                )
            }else{
                let data = this.state.userData;
                let outArray = [data.name, data.email, data.phone, data.role];
                sessionStorage.setItem('userinfo',outArray);
                sessionStorage.setItem('loginStatus',true)
                return(
                    <><nav style={{backgroundColor:'#dedcd3'}}className="navbar navbar-inverse">
                    <div>
                    <span className="nav navbar-nav navbar-left">
                            <li style={{ fontFamily: 'Raleway', color:'Highlight'}}><Link to="/" id="nav_a">FoodieBay</Link></li>
                        </span>
                    <ul className="nav navbar-nav navbar-right">
                    <Link to="/" className="btn btn-success">
                        <span className="glyphicon glyphicon-user"></span> Hi {data.name}
                    </Link> &nbsp;
                    <button onClick={this.handleLogout} className="btn btn-outline-danger">Logout</button>
                    </ul>
                    </div>
            </nav>
                    </>
                )
            }

        }else{
            return(
                <><nav style={{backgroundColor:'#dedcd3'}}className="navbar navbar-inverse">
                <div className="container-fluid">
                <div id="zomatoNav">
                <span className="nav navbar-nav navbar-left">
                            <li><Link to="/" id="nav_a">FoodieBay</Link></li>
                        </span>
                        <ul className="nav navbar-nav navbar-right">
                 
                            <li> 
                            <Link  to="/login" id="nav_a"><span className="glyphicon glyphicon-log-in"></span> Login</Link></li>
                            <li><Link to="/register" id="nav_a"> <span className="glyphicon glyphicon-user"></span>Sign Up</Link></li> 
                            <li>
                            <a  id="nav_a" href="https://github.com/login/oauth/authorize?client_id=8461390d1c68e1da8d1e">Login with &nbsp;  
                            <img src={"https://i.postimg.cc/wvRX512T/github.png"}/>
                            </a></li>
                        </ul>
                    </div>
                    </div>
            </nav>
                </>
            )
        }
        
    }

    render(){
        return(

           
                       <div id="">{this.conditionalHeader()}</div>
                     
        )
    }

    //getuser info after login 
    componentDidMount(){
        /* Login With GIT */
        if(this.props.location.search){
            console.log(this.props.location.search)
            if(this.props.location.search.split('=')[0] == '?code'){
                var code = this.props.location.search.split('=')[1]
            }

            if(code){
                let requestedData={
                    code:code
                }
                fetch(`https://foodiebay-login-withgit.onrender.com/oauth`,{
                    method: 'POST',
                    headers:{
                        'Accept':'application/json',
                        'Content-Type':'application/json'

                    },
                    body: JSON.stringify(requestedData)
                })
                .then((res) => res.json())
                .then((data) => {
                    let username = data.name;
                    let email = data.email;
                    let img = data.avatar_url;
                    sessionStorage.setItem('uName',username)
                    sessionStorage.setItem('uImg',img);
                    sessionStorage.setItem('loginStatus',true)
                    this.setState({username:username,userImg:img})
                })
            }
        }
        /* Login With JWT */
        fetch(url,{
            method: 'GET',
            headers:{
                'x-access-token':sessionStorage.getItem('ltk')
            }
        })
        .then((res) =>  res.json())
        .then((data) => {
            this.setState({
                userData:data
            })
        })
    }
}

export default withRouter(Header)